// The supplier overview's switcher and the Vergleich (docs/suppliers.md, "Auswertungen"). Names, dates, units
// and prices are never parameters (the bundle escapes them); the components put them together.
export default {
  views: {
    suppliers: "Suppliers",
    comparison: "Comparison",
  },
  not_set_up: "The analyses are available once the purchase prices are assigned to suppliers.",
  kinds: {
    ALL: "All",
    MATERIAL: "Materials",
    MACHINE: "Machines",
  },
  comparison: {
    title: "Compare suppliers",
    subtitle: "Where you get materials and machines cheapest.",
    // The choice at the top of each of the two cards.
    supplier: "Supplier",
    filter: {
      MATERIAL: "Filter materials",
      MACHINE: "Filter machines",
    },
    // What the figures are: neither card nor row can say it.
    prices_info:
      "Prices per unit less discount, without quantity prices and freight. An item's Purchasing tab shows the price delivered to site for a quantity.",
    // Under the supplier in its card: for how many shared items it is the cheaper one.
    cheaper_count: "Cheaper for {n} of {total}",
    // From three cards on instead of 'Cheaper for': for how many shared items it is the cheapest.
    cheapest_count: "Cheapest for {n} of {total}",
    // The dashed card after the last: one more supplier, up to six.
    add_supplier: "Add supplier",
    is_standard: "Your default",
    shared_none: {
      MATERIAL: "No material in common.",
      MACHINE: "No machine in common.",
    },
    // Under a card, what only this supplier carries; the component appends name and count.
    only: "Only at",
    pick: "Choose two suppliers.",
    // In an added card while its supplier is missing.
    pick_one: "Choose a supplier.",
    // Without an item two suppliers have prices for: nothing for the cards to open with.
    empty: {
      MATERIAL: "No material has prices from two suppliers yet.",
      MACHINE: "No machine has prices from two suppliers yet.",
    },
    no_match: "Nothing found.",
    truncated: "The first 1000 – the filter narrows it down.",
    per: "per",
    other_currency: "other currency",
    // A machine row per hour beside rows per day, week or month: not compared.
    other_unit: "other unit",
    // Instead of the cards' contents when the server refuses the pair.
    refused: {
      archived: "Archived suppliers cannot be compared.",
      unknown: "One of the suppliers no longer exists.",
      other: "The comparison could not be loaded.",
    },
    no_kind: "The comparison needs the right to see purchase prices of machines or materials.",
  },
  // Compare materials / machines: two items side by side, the rows are the suppliers of both.
  item_comparison: {
    title: {
      MATERIAL: "Compare materials",
      MACHINE: "Compare machines",
    },
    subtitle: {
      MATERIAL: "Two materials and what they cost at your suppliers.",
      MACHINE: "Two machines and what they cost at your suppliers.",
    },
    pick_label: {
      MATERIAL: "Material",
      MACHINE: "Machine",
    },
    pick: {
      MATERIAL: "Choose a second material.",
      MACHINE: "Choose a second machine.",
    },
    // Under the name in the card; price, currency and unit follow.
    typical: "Usually",
    shared_none: "No suppliers in common.",
    // Under a card, the suppliers of this item only; the component appends name and count.
    only: "Only for",
    units_differ: "Different units: prices not compared.",
  },
}
